import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Clock, GitMerge, Timer, BarChart3 } from 'lucide-react';
export function MechanismReveal() {
  const features = [{
    icon: <GitMerge className="w-6 h-6 text-[#5b8a7a]" data-id="element-220" />,
    title: 'Árbol de Decisión 2AM',
    desc: 'Una sola página para saber qué camino tomar.'
  }, {
    icon: <FileText className="w-6 h-6 text-[#5b8a7a]" data-id="element-221" />,
    title: 'Guion Base de 90 Segundos',
    desc: 'Para bajar tu activación y elegir ruta.'
  }, {
    icon: <Clock className="w-6 h-6 text-[#5b8a7a]" data-id="element-222" />,
    title: 'Rutas A / B / C / D / E',
    desc: 'Hambre, incomodidad, gases, contacto, transferencia.'
  }, {
    icon: <Timer className="w-6 h-6 text-[#5b8a7a]" data-id="element-223" />,
    title: 'Regla 8–12 Minutos',
    desc: 'Si no mejora en este tiempo, cambias. Sin espirales.'
  }, {
    icon: <BarChart3 className="w-6 h-6 text-[#5b8a7a]" data-id="element-224" />,
    title: 'Tracker de 14 Noches',
    desc: 'Para detectar patrones sin obsesionarte.'
  }];
  return <section className="w-full bg-white py-20 px-4" data-id="element-225">
      <div className="max-w-4xl mx-auto" data-id="element-226">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-227">
          <span className="text-[#e8856c] font-medium tracking-widest text-sm uppercase mb-4 block" data-id="element-228">
            Presentando
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-[#0f172a] mb-6 leading-tight" data-id="element-229">
            2AM Newborn Sleep <br data-id="element-230" />
            <span className="text-[#5b8a7a]" data-id="element-231">"Panic-to-Plan" Scripts</span>
          </h2>
          <p className="text-lg text-[#64748b] max-w-2xl mx-auto" data-id="element-232">
            Diseñado para una sola cosa: que cuando llegue el colapso nocturno,{' '}
            <span className="font-semibold text-[#0f172a]" data-id="element-233">no improvises.</span>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-234">
          {features.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#faf7f2] p-6 rounded-xl border border-[#f1f5f9] hover:border-[#5b8a7a]/30 transition-colors" data-id="element-235">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm mb-4" data-id="element-236">
                {feature.icon}
              </div>
              <h3 className="font-serif text-xl text-[#0f172a] mb-2 font-medium" data-id="element-237">
                {feature.title}
              </h3>
              <p className="text-[#64748b] leading-relaxed" data-id="element-238">{feature.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}